<template>
  <div class="animated fadeIn">
    <b-card size="sm" footer-bg-variant="white" footer-border-variant="white">
      <div slot="header">
        <i class="icon-note"></i> DC Detail
      </div>

      <b-card-body>
        <div>
          <b-form id="employeeForm" validated novalidate>
            <div v-if="loading == true">
              <div class="sk-spinner sk-spinner-pulse"></div>
              <p class="text-center" style="color: #CCC;">Please wait . . .</p>
            </div>

            <div v-if="loading == false">
              <b-row>
                <b-col sm="3">
                  <b-form-group label-for="name" label="Nama DC">
                    <b-form-input
                      id="name"
                      type="text"
                      v-model="$v.distributionCenterForm.name.$model"
                      :state="!$v.distributionCenterForm.name.$invalid"
                      required
                      placeholder="Nama DC"
                    ></b-form-input>
                    <b-form-invalid-feedback>Nama DC harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col sm="3">
                  <b-form-group label-for="dc_code" label="Kode DC">
                    <b-form-input
                      id="dc_code"
                      type="text"
                      v-model="$v.distributionCenterForm.dc_code.$model"
                      :state="!$v.distributionCenterForm.dc_code.$invalid"
                      required
                      placeholder="Kode DC"
                    ></b-form-input>
                    <b-form-invalid-feedback>Kode DC harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col sm="3">
                  <b-form-group label-for="zone" label="Zona">
                    <model-select
                      id="zone"
                      :options="listZone"
                      v-model="$v.distributionCenterForm.zone.$model"
                      :isError="$v.distributionCenterForm.zone.$invalid"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                    <div
                      v-if="distributionCenterForm.zone === null"
                      class="invalid-feedback-custom"
                    >Zona harus di isi.</div>
                  </b-form-group>
                </b-col>
                <b-col sm="3">
                  <b-form-group label-for="owner_name" label="Nama Pemilik">
                    <b-form-input
                      id="owner_name"
                      type="text"
                      v-model="$v.distributionCenterForm.owner_name.$model"
                      :state="!$v.distributionCenterForm.owner_name.$invalid"
                      required
                      placeholder="Nama Pemilik"
                    ></b-form-input>
                    <b-form-invalid-feedback>Nama Pemilik harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="3">
                  <b-form-group label-for="lat" label="Latitude">
                    <b-form-input
                      id="lat"
                      type="text"
                      v-model="$v.distributionCenterForm.lat.$model"
                      :state="!$v.distributionCenterForm.lat.$invalid"
                      required
                      placeholder="Latitude"
                    ></b-form-input>
                    <b-form-invalid-feedback>Latitude harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col sm="3">
                  <b-form-group label-for="lng" label="Longitude">
                    <b-form-input
                      id="lng"
                      type="text"
                      v-model="$v.distributionCenterForm.lng.$model"
                      :state="!$v.distributionCenterForm.lng.$invalid"
                      required
                      placeholder="Longitude"
                    ></b-form-input>
                    <b-form-invalid-feedback>Longitude harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col sm="3">
                  <b-form-group label-for="mobile_phone" label="Mobile Phone">
                    <b-form-input
                      id="mobile_phone"
                      type="text"
                      v-model="$v.distributionCenterForm.mobile_phone.$model"
                      :state="!$v.distributionCenterForm.mobile_phone.$invalid"
                      required
                      placeholder="Mobile Phone"
                    ></b-form-input>
                    <b-form-invalid-feedback>Mobile Phone harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col sm="3">
                  <b-form-group label-for="mobile_phone2" label="Mobile Phone 2">
                    <b-form-input
                      id="mobile_phone2"
                      type="text"
                      v-model="$v.distributionCenterForm.mobile_phone2.$model"
                      :state="!$v.distributionCenterForm.mobile_phone2.$invalid"
                      placeholder="Mobile Phone 2"
                    ></b-form-input>
                    <b-form-invalid-feedback>Mobile Phone 2 harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="3">
                  <b-form-group label-for="bank_account_name" label="Nama Rekening">
                    <b-form-input
                      id="bank_account_name"
                      type="text"
                      v-model="$v.distributionCenterForm.bank_account_name.$model"
                      :state="!$v.distributionCenterForm.bank_account_name.$invalid"
                      placeholder="Nama Rekening"
                    ></b-form-input>
                    <b-form-invalid-feedback>Nama Rekening harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col sm="3">
                  <b-form-group label-for="bank_account_number" label="Nomor Rekening">
                    <b-form-input
                      id="bank_account_number"
                      type="text"
                      v-model="$v.distributionCenterForm.bank_account_number.$model"
                      :state="!$v.distributionCenterForm.bank_account_number.$invalid"
                      placeholder="Nomor Rekening"
                    ></b-form-input>
                    <b-form-invalid-feedback>Nomor Rekening harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col sm="3">
                  <b-form-group label-for="mitra" label="Jenis">
                    <model-select
                      id="mitra"
                      :options="listMitra"
                      v-model="$v.distributionCenterForm.mitra.$model"
                      :isError="$v.distributionCenterForm.mitra.$invalid"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                    <div
                      v-if="distributionCenterForm.mitra === null"
                      class="invalid-feedback-custom"
                    >Jenis DC harus di isi.</div>
                  </b-form-group>
                </b-col>

                <b-col sm="3">
                  <b-form-group label-for="status" label="Status">
                    <model-select
                      id="status"
                      :options="listStatus"
                      v-model="$v.distributionCenterForm.status.$model"
                      :isError="$v.distributionCenterForm.status.$invalid"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                    <div
                      v-if="distributionCenterForm.status === null"
                      class="invalid-feedback-custom"
                    >Status harus di isi.</div>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="6">
                  <b-form-group label-for="address" label="Alamat">
                    <b-form-textarea
                      id="address"
                      :rows="3"
                      :max-rows="6"
                      v-model="$v.distributionCenterForm.address.$model"
                      :state="!$v.distributionCenterForm.address.$invalid"
                      required
                    ></b-form-textarea>
                    <b-form-invalid-feedback>Alamat harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>

              <div slot="footer" class="text-right">
                <b-button type="button" size="sm" variant="danger" @click="back">
                  <i class="fa fa-undo"></i> Back
                </b-button>&nbsp;
                <b-button
                  v-if="notAllowEdit"
                  type="button"
                  size="sm"
                  variant="primary"
                  @click="editDistributionCenter"
                  :disabled="$v.distributionCenterForm.$invalid"
                >
                  <i class="fa fa-save"></i> Save
                </b-button>
              </div>
            </div>
          </b-form>
        </div>
      </b-card-body>
    </b-card>

    <b-card size="sm" footer-bg-variant="white" footer-border-variant="white">
      <b-tabs>
        <b-tab title="Cakupan Zone" active>
          <global-table
            :table-data="coverageZone"
            :loading="loading"
            :per-page="10"
            :table-detail="tableDetail"
            :bordered="true"
            :hover="true"
            :striped="false"
            :id-modals="'dcCoverageZone'"
            :redirect-detail="false"
            :edit-button="false"
            :show-add-button="childAddButton && notAllowEdit"
            :remove-button="notAllowEdit"
            :fields="fieldCoverageZone"
            addButton="Tambah Zona"
            @editForm="editCoverageZone"
            @resetForm="resetForm"
            @removeForm="removeCoverageZone"
          ></global-table>

          <b-modal
            ref="dcCovergeZoneForm"
            id="dcCoverageZone"
            header-border-variant="no-border text-center"
            footer-border-variant="no-border"
            footer-bg-variant="light"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
            size="lg"
          >
            <div slot="modal-header" class="text-center">
              <h3 class="text-center">Cakupan Zona</h3>
            </div>

            <b-form id="dcCovergeZoneForm" validated novalidate>
              <div v-if="!loadingFormModal">
                <b-row>
                  <b-col sm="3">
                    <b-form-group label-for="zone" label="Kode Sub Zona">
                      <model-select
                        id="zone"
                        :options="listZone"
                        v-model="$v.dcCovergeZoneForm.zone.$model"
                        :isError="$v.dcCovergeZoneForm.zone.$invalid"
                        placeholder="-- Harap pilih salah satu --"
                      ></model-select>
                      <div
                        v-if="dcCovergeZoneForm.zone === null"
                        class="invalid-feedback-custom"
                      >Zona harus di isi.</div>
                    </b-form-group>
                  </b-col>
                </b-row>
              </div>
              <div v-else>
                <loading></loading>
              </div>
            </b-form>

            <div slot="modal-footer" class="float-right">
              <div v-if="!loadingFormModal">
                <b-button type="button" size="sm" variant="danger" @click="cancelCoverageZone">
                  <i class="fa fa-undo"></i> Back
                </b-button>&nbsp;
                <b-button
                
                  type="button"
                  size="sm"
                  variant="primary"
                  @click="saveCoverageZone"
                  :disabled="$v.dcCovergeZoneForm.$invalid"
                >
                  <i class="fa fa-save"></i> Save
                </b-button>
              </div>
            </div>
          </b-modal>
        </b-tab>

        <b-tab title="List Customer">
          <global-table
            :table-data="listCustomerDC"
            :loading="loading"
            :per-page="20"
            :table-detail="tableDetail"
            :bordered="true"
            :hover="true"
            :striped="false"
            :filter="true"
            :id-modals="'listCustomerDc'"
            :filter-table-only="true"
            :show-add-button="false"
            :redirect-detail="false"
            :edit-button="false"
            :fields="fieldCustomerDC"
          ></global-table>
        </b-tab>
      </b-tabs>

      
    </b-card>
  </div>
</template>

<script>
import axios from "axios";
import globalTable from "../../templates/Table.vue";
import interfaces from "@/templates/_interfaces.js";
import custom_validation from "@/templates/_customValidation.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import * as moment from "moment";
import "moment/locale/id";
import { ModelSelect } from "vue-search-select";
import loading from "@/templates/Loading.vue";

export default {
  name: "distribution-center-detail",
  components: { globalTable, ModelSelect, loading },
  props: {
    tableDetail: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      listZone: [],
      listCustomerDC: [],
      listMitra: [{ value: "1", text: "DC" }, { value: "2", text: "Mitra" }],
      listStatus: [
        { value: "1", text: "Aktif" },
        { value: "2", text: "Tidak Aktif" }
      ],
      isEdit: false,
      loading: true,
      loadingFormModal: false,
      distributionCenterForm: interfaces.distribution_center,
      dcCovergeZoneForm: interfaces.distribution_center_zone,
      coverageZone: [],
      fieldCoverageZone: [
        { key: "zone", label: "Zona", sortable: true },
        { key: "action", label: "Action", class: "text-center width-100" }
      ],
      fieldCustomerDC: [
        { key: "customer_detail", label: "Nama Konsumen", sortable: true, class: "width-350" },
        {
          key: "sub_zone_code",
          label: "Sub Zona DC",
          sortable: false, class: "width-150"
        },
         {
          key: "zone",
          label: "Zona",
          sortable: false, class: "width-150"
        },
        { key: "address", label: "Alamat", sortable: false },
        { key: "address_ktp", label: "Alamat KTP", sortable: false },
        { key: "lat_long", label: "Lat / Long", sortable: false }
      ]
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  validations: {
    distributionCenterForm: {
      name: { required },
      dc_code: { required },
      zone: { required },
      lat: { required },
      lng: { required },
      owner_name: { required },
      address: { required },
      mobile_phone: { required },
      mobile_phone2: {},
      mobile_phone3: {},
      bank_account_name: {},
      bank_account_number: {},
      status: { required },
      mitra: { required }
    },
    dcCovergeZoneForm: {
      zone: { required },
      dc_id: { }
    }
  },
  computed: {
    childAddButton() {
      return localStorage.getItem("level") === "1" ? true : false;
    },
    notAllowEdit() {
      let nik = localStorage.getItem("nik");
      return (['MBS25100001'].includes(nik)) ? false: true;
    }
  },
  methods: {
    init: function(dc_id) {
      this.loading = true;
      this.getDistributionDetail(dc_id);
      this.getDropdown();
    },
    getDistributionDetail(dc_id) {
      this.axios
        .get("web/distribution_center/detail/" + dc_id + "/")
        .then(response => {
          this.distributionCenterForm = response.data.data;
          this.coverageZone = response.data.dc_zone;
          this.listCustomerDC = response.data.list_customer;
        })
        .catch(error => {})
        .finally(() => {
          this.loading = false;
        });
    },
    getDropdown() {
      this.axios
        .get("web/dropdown/dropdown-distribution-center/")
        .then(response => {
          this.listZone = response.data.zone;
        })
        .catch(error => {})
        .finally(() => {
          this.loading = false;
        });
    },
    back: function() {
      this.$router.go(-1);
    },
    resetForm: function() {
      for (var a in interfaces.distribution_center_zone) {
        interfaces.distribution_center_zone[a] = null;
      }
      this.dcCovergeZoneForm = interfaces.distribution_center_zone;
      this.isEdit = false;
    },
    editDistributionCenter: function(evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin merubah konsumen ini ?")) {
        this.axios
          .put(
            "web/distribution_center/change-distribution-center/",
            this.distributionCenterForm
          )
          .then(response => {
            let _detailData = response.data.data;
            this.showInfoNotification({
              title: "Ubah Distribution Center",
              message: response.data.message
            });
          })
          .catch(error => {
            this.expired(error, "Ubah Distribution Center");
          })
          .finally(() => {
            let route = this.$route.path.split("/");
            this.init(route[4]);
          });
      }
    },
    cancelCoverageZone: function() {
      this.resetForm();
      this.$refs.dcCovergeZoneForm.hide();
    },
    saveCoverageZone: function(evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin menambahkan cakupan zona ?")) {
        this.loadingFormModal = true;
        let route = this.$route.path.split("/");
        let dcCoverage = this.dcCovergeZoneForm;
        dcCoverage.dc_id = route[4];
        dcCoverage.dc_code = this.distributionCenterForm.dc_code;

        this.axios
          .post("web/distribution_center/add-distribution-center-zone/", dcCoverage)
          .then(response => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: "Tambah cakupan zona",
                message: response.data.message
              });
            } else if (response.data.status === 4000) {
              this.showErrorNotification({
                title: "Tambah cakupan zona",
                message: response.data.message
              });
            }
            this.cancelCoverageZone();
          })
          .catch(error => {
            this.expired(error, "Tambah asset konsumen");
          })
          .finally(() => {
            this.loadingFormModal = false;
            let route = this.$route.path.split("/");
            this.init(route[4]);
          });
      }
    },
    editCoverageZone: function(evt) {
      this.isEdit = true;
      this.dcCovergeZoneForm = evt;
    },
    removeCoverageZone: function(data) {
      if (confirm("Apakah anda ingin menghapus zona ini dari DC ?")) {
        this.axios
          .delete("web/distribution_center/remove-distribution-center-zone/" + data.id)
          .then(response => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: "Hapus dokumen konsumen",
                message: response.data.message
              });
            }
          })
          .catch(error => {
            this.expired(error, 'Hapus dokumen konsumen');
          })
          .finally(() => {
            let route = this.$route.path.split("/");
            this.init(route[4]);
          });
      }
    },
    expired: function(error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message
        });
      }
    }
  },
  mounted() {
    let route = this.$route.path.split("/");
    this.init(route[4]);
  }
};
</script>

<style>
</style>
